import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  rating: number;  // Rating en pourcentage (0-100)
  totalVotes?: number;
  showVoteCount?: boolean;
  className?: string;
}

export function StarRating({ rating, totalVotes = 0, showVoteCount = true, className = '' }: StarRatingProps) {
  // Convertir le pourcentage (0-100) en note sur 5 étoiles
  const starRating = (rating / 100) * 5;
  
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => {
          const filled = starRating >= star;
          const partiallyFilled = !filled && starRating > star - 1;
          
          return (
            <Star
              key={star}
              className={`${
                className.includes('text-xl') ? 'w-6 h-6' : 'w-4 h-4'
              } ${
                filled
                  ? 'text-yellow-400 fill-yellow-400'
                  : partiallyFilled
                  ? 'text-yellow-400 fill-yellow-400/50'
                  : 'text-gray-300'
              }`}
            />
          );
        })}
      </div>
      
      {showVoteCount && totalVotes > 0 && (
        <span className="text-sm text-gray-500 ml-2">
          ({totalVotes} vote{totalVotes > 1 ? 's' : ''})
        </span>
      )}
    </div>
  );
}
